"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Media = void 0;
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash/noop"));
const media_image_wrapper_1 = require("./components/media-image-wrapper");
const styles_1 = require("./styles");
const types_1 = require("./types");
const Media = (props) => {
    const { controls, controlState } = props, rest = __rest(props, ["controls", "controlState"]);
    const { mediaSrcType, mediaSrcUrl, autoPlay = true, loop = false, playsInline = true, initialFrame = undefined, id = undefined, title = undefined, muted = true, onPlay = noop_1.default, onPause = noop_1.default, onClick } = rest;
    const tabAccessibilityProps = () => onClick
        ? { onKeyDown: (event) => event.key === 'Enter' && onClick(event), tabIndex: 0 }
        : {};
    const mediaRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (controlState !== undefined) {
            playOrPauseVideo(controlState);
        }
    }, [controlState]);
    const playOrPauseVideo = (controlState) => __awaiter(void 0, void 0, void 0, function* () {
        if (mediaRef && mediaRef.current) {
            if (controlState === types_1.MediaControlState.Pause) {
                mediaRef.current.pause();
            }
            else {
                yield mediaRef.current.play();
            }
        }
    });
    const renderImage = () => {
        return react_1.default.createElement(media_image_wrapper_1.MediaImageWrapper, Object.assign({ "data-cy": 'media-image' }, props, tabAccessibilityProps(), { title: title }));
    };
    const renderAudio = () => {
        return (react_1.default.createElement("audio", Object.assign({ ref: mediaRef }, (controls ? { controls } : {}), { src: mediaSrcUrl, autoPlay: autoPlay, loop: loop, id: id, title: title, "data-cy": 'media-audio', onPlay: onPlay, onPause: onPause })));
    };
    const renderVideo = () => {
        return (react_1.default.createElement(styles_1.MediaVideo, Object.assign({ ref: mediaRef }, rest, (controls ? { controls } : {}), { muted: muted, autoPlay: autoPlay, src: mediaSrcUrl, loop: loop, playsInline: playsInline, poster: initialFrame, id: id, title: title, "data-cy": 'media-video', onPlay: onPlay, onPause: onPause }, tabAccessibilityProps())));
    };
    switch (mediaSrcType) {
        case types_1.MediaType.Image:
            return renderImage();
        case types_1.MediaType.Audio:
            return renderAudio();
        case types_1.MediaType.Video:
            return renderVideo();
        default:
            return null;
    }
};
exports.Media = Media;
exports.default = exports.Media;
